import { render, staticRenderFns } from "./LimitReachedOverlay.vue?vue&type=template&id=3684afbd&scoped=true&"
import script from "./LimitReachedOverlay.vue?vue&type=script&lang=js&"
export * from "./LimitReachedOverlay.vue?vue&type=script&lang=js&"
import style0 from "./LimitReachedOverlay.vue?vue&type=style&index=0&id=3684afbd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3684afbd",
  null
  
)

export default component.exports